// extracted by mini-css-extract-plugin
export default {"newUserModal":"NewUserModal_newUserModal__mhpUh","loader":"NewUserModal_loader__RFL+V"};